<template>
    <div>
        <div v-if="!previewUnsupported">
            <div id="pdf-preview"></div>
        </div>
        <div class="alert alert-info" v-if="previewUnsupported">Your browser does not support PDF preview!</div>
    </div>
</template>

<script>
    import PDFObject from 'pdfobject'

    export default {
        name: "pdf-preview",

        props: ['filename'],

        data() {
            return {
                config: {
                    height: "70rem",
                    pdfOpenParams: {view: 'FitV'},
                    forcePDFJS: true
                },
                previewUnsupported: false,
                pdfPath: null
            }
        },

        watch: {
            filename: function () {
                this.renderPDF()
            }
        },

        methods: {
            renderPDF() {
                $(this.$el).html($('<object style="overflow: auto; width: 100%; height: 70rem;" data="'+ this.filename + '#zoom=page-fit&view=FitV" type="application/pdf">Your browser does not support PDF preview. <a target="_blank" href="' + this.filename + '">Click here to download your file</a></object>'));
            }
        },

        mounted() {
            this.renderPDF()
        }
    }
</script>

<style scoped>
    .pdfobject {
        border: 1px solid #666;
    }
</style>